import { reportDefinitionsApi, type ReportDefinitionPage, type ReportDefinitionSend, type ReportDefinitionSummary } from './api';
import type { ReportDefinitionsBoard } from './report-definitions-board.svelte';

/**
 * Os envios de uma linha, uma página por vez, do mais novo ao mais antigo. Trocar de página rápido não deixa a
 * resposta atrasada da anterior tomar o lugar; a página que falha não apaga a que está na tela.
 */
export class ReportDefinitionSends {
  page = $state<ReportDefinitionPage<ReportDefinitionSend> | null>(null);
  /** A página que não carregou, para tentar de novo; nula quando a última carregou. */
  failedPage = $state<number | null>(null);
  /** O envio mais novo abre sozinho na primeira página: é o que se veio ver. */
  expanded = $state<string | null>(null);
  private latestRequest = 0;

  constructor(private readonly board: ReportDefinitionsBoard) {}

  get failedBeforeAnyPage(): boolean {
    return this.page === null && this.failedPage !== null;
  }

  async load(definition: ReportDefinitionSummary, page = 1): Promise<void> {
    const request = ++this.latestRequest;
    try {
      const loaded = await reportDefinitionsApi.sends(definition, page);
      if (request !== this.latestRequest) return;
      this.page = loaded;
      this.failedPage = null;
      this.expanded = page === 1 ? (loaded.items[0]?.reportId ?? null) : null;
    } catch (err) {
      if (request !== this.latestRequest) return;
      this.failedPage = page;
      this.board.fail(err);
    }
  }

  toggle(reportId: string): void {
    this.expanded = this.expanded === reportId ? null : reportId;
  }
}
